import Axios from './base';

export const CreateInspectionBuilder = (entity) => Axios().post('Inspection/CreateInspections', entity)

export const simulateMyInspection = (entity) => Axios().post('Inspection/SimulateInspection', entity)
export const UpdateSimulateInspection = (id,entity) => Axios().post('Inspection/UpdateSimulateInspection/'+id, entity)
export const GetSimulateInspection = (id)=> Axios().get('Inspection/GetSimulateInspection/'+id)

export const getInspectionBuilder = () => Axios().get('Inspection/GetInspections')

export const UpdateInspectionBuilder = (id, entity) => Axios('Updated Successfully').put('Inspection/UpdateInspections/' + id, entity)

export const getInspectionsById = (id) => Axios(null,"Invalid Id").get('Inspection/getInspectionsById/' + id,)
export const getMyInspection = (id) => Axios().get('Inspection/GetMyInspections/' + id)
export const getMyInspectionPaginated = (id, params) => Axios().get('Inspection/GetMyInspectionsPaginated/' + id, { params })
export const getAllMyInspections = ()=>Axios().get('Inspection/GetAllMyInspections')
export const UploadFile = (entity) => Axios().post('uploadfile', entity)
export const DownloadFile = (key) => Axios(null, null, { responseType: 'blob' }).get('downloadfile/' + key)
